import React from 'react';
import { DataTable } from '../../../../../ui';
import { getColumns } from './Functions';
import { useUsersTab } from './Hooks';

interface IUsersTabProps {
  searchTerm?: string;
}

export const UsersTab = ({ searchTerm }: IUsersTabProps) => {
  const {
    usersData,
    onPageChange,
    pageNumber,
    totalPages,
    loading,
    history,
    totalRecords,
  } = useUsersTab(searchTerm);

  return (
    <div className='relative w-full'>
      <DataTable
          isLoading={loading}
          columns={getColumns}
          data={usersData}
          rowsPerPage={10}
          onPageChange={onPageChange}
          currentPage={pageNumber}
          totalPages={totalPages}
          onClickRow={(row) => {
            history.push('/employee-management');
          }}
          totalRecords={totalRecords}
      />
    </div>
  );
};
